import { convertPrices } from '../utils/storefront'
import { sendKlevuAnalytics } from '../utils/klevu'

export default () => ({
    open: false,
    term: Alpine.$persist('').as('search-term').using(sessionStorage),
    productResults: Alpine.$persist([])
        .as('search-productResults')
        .using(sessionStorage),
    newsResults: Alpine.$persist([])
        .as('search-newsResults')
        .using(sessionStorage),
    totalResults: Alpine.$persist(0)
        .as('search-totalResults')
        .using(sessionStorage),
    suggestedTerms: Alpine.$persist([])
        .as('search-suggestedTerms')
        .using(sessionStorage),
    urlRedirects: Alpine.$persist([])
        .as('search-urlRedirects')
        .using(sessionStorage),
    currency: {
        ...shopifyData.currency,
        code: Alpine.$persist('')
            .as('search-currencyCode')
            .using(sessionStorage),
    },
    loading: false,

    init() {
        if (!this.currency.code) this.currency.code = this.currency.iso_code

        if (this.currency.code !== shopifyData.currency.iso_code) {
            this.resetProductData()
            this.currency.code = shopifyData.currency.iso_code
        }

        if (!this.suggestedTerms.length) this.fetchSuggestedTerms()
        if (!this.urlRedirects.length) this.fetchUrlRedirects()

        this.$watch('term', () => this.search())

        window.addEventListener('search:toggle', (open) => {
            this.toggle()

            if (open) {
                this.$nextTick(() =>
                    document.querySelector('#search-input').focus()
                )
            }
        })
    },

    toggle(bool) {
        this.open = bool ?? !this.open
    },

    resetProductData() {
        this.productResults = []
        this.totalResults = 0
        this.term = ''
    },
    navigateToSearchResultsPage() {
        let url = `${Shopify.routes.root ?? '/'}search?q=${encodeURIComponent(this.term.trim())}`

        if (this.urlRedirects.length) {
            const term = this.term.trim().toLowerCase()

            this.urlRedirects.some((redirect) => {
                if (redirect.keywords.includes(term)) {
                    url = redirect.url
                }
            })
        }

        window.location.href = url
    },
    search() {
        if (!this.term) {
            this.resetProductData()
            return
        }

        this.loading = true

        const request = {
            recordQueries: [
                {
                    id: 'productSearch',
                    typeOfQuery: 'SEARCH',
                    settings: {
                        typeOfSearch: 'FUZZY_AND',
                        query: {
                            term: this.term,
                        },
                        sort: 'RELEVANCE',
                        limit: 6,
                        fields: [
                            'id',
                            'itemGroupId',
                            'name',
                            'price',
                            'startPrice',
                            'salePrice',
                            'url',
                            'image',
                            'imageHover',
                            'additionalDataToReturn',
                            'tag'
                        ],
                        typeOfRecords: ['KLEVU_PRODUCT'],
                    },
                },
                {
                    id: 'newsSearch',
                    typeOfQuery: 'SEARCH',
                    settings: {
                        query: {
                            term: this.term,
                        },
                        sort: 'RELEVANCE',
                        limit: 6,
                        fields: ['name', 'url', 'image'],
                        customANDQuery: 'type:("articles")',
                        typeOfRecords: ['KLEVU_CMS'],
                    },
                },
            ],
            context: {
                apiKeys: [shopifyData.klevuApi.key],
            },
        }

        fetch(shopifyData.klevuApi.searchUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
            },
            body: JSON.stringify(request),
        })
            .then((response) => response.json())
            .then(async (data) => {
                const productResultsData = data.queryResults.find(
                    (query) => query.id === 'productSearch'
                )
                const newsResultsData = data.queryResults.find(
                    (query) => query.id === 'newsSearch'
                )

                let productResults = productResultsData.records.map(
                    (record) => {
                        const url = new URL(record.url)

                        record.url = `${Shopify.routes.root}${url.pathname.replace(/^\//, '')}`
                        record.price = record.price * 100
                        record.startPrice = record.startPrice * 100
                        record.salePrice = record.salePrice * 100
                        record.imageUrl = this.cleanImageSrc(record.imageUrl)
                        record.imageHover = this.cleanImageSrc(record.imageHover)
                        record.variants = JSON.parse(record.additionalDataToReturn)?.variants || []

                        return record
                    }
                )

                productResults = await convertPrices(productResults).then(
                    (productResults) => {
                        this.productResults = productResults
                        this.loading = false
                    }
                )

                this.totalResults = productResultsData.meta.totalResultsFound

                const newsResults = newsResultsData.records.map((record) => {
                    const url = new URL(record.url)

                    record.url = `${Shopify.routes.root}${url.pathname.replace(/^\//, '')}`
                    record.imageUrl = this.cleanImageSrc(record.imageUrl)
                    return record
                })
                this.newsResults = newsResults

                const analyticsUrl = `https://stats.ksearchnet.com/analytics/n-search/search?apiKey=${shopifyData.klevuApi.key}&term=${encodeURIComponent(this.term)}&klevu_totalResults=${this.totalResults}&klevu_typeOfQuery=FUZZY_AND`

                fetch(analyticsUrl, {
                    method: 'GET',
                    headers: {},
                })
            })
            .catch((err) => {
                console.error(err)
            })
    },
    fetchSuggestedTerms() {
        fetch(
            `https://js.klevu.com/klevu-js-v1/klevu-js-api/${shopifyData.klevuApi.key}.json`
        )
            .then((response) => response.json())
            .then(
                (data) =>
                    (this.suggestedTerms = data.klevu_webstorePopularTerms)
            )
    },
    fetchUrlRedirects() {
        fetch(
            `https://js.klevu.com/klevu-js-v1/klevu-js-api/${shopifyData.klevuApi.key}-maps.json`
        )
            .then((response) => response.json())
            .then((data) => (this.urlRedirects = data.klevu_keywordUrlMap))
    },
    handleProductClick(e, result, term) {
        sendKlevuAnalytics(e, result, term)
    },
    cleanImageSrc(src) {
        return src.replace('_medium', '')
    },
})
